import { Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";


export default function DashboardTile({ label, value, value2, value3, icon, valueFontSize }) {

	const theme = useTheme();

	let colors = {
		displaybackground: theme.palette.DashboardTile.maindisplay.background,
		displayfontcolor: theme.palette.DashboardTile.maindisplay.color,
		displayfontsize: theme.palette.DashboardTile.maindisplay.fontSize,
		displayfontweight: theme.palette.DashboardTile.maindisplay.fontWeight,


		bannerfontcolor: theme.palette.DashboardTile.banner.color,
		bannerbackground: theme.palette.DashboardTile.banner.background,
		bannerfontweight: theme.palette.DashboardTile.banner.fontWeight,
		bannerfontsize: theme.palette.DashboardTile.banner.fontSize,
	}

	return (

		<Box variant="outlined"
			sx={{
				width: "100%",
				minWidth: 250,
				minHeight: 175,
				background: colors.displaybackground,
			}}>


			<Typography
				align="center"
				sx={{
					mb: 1,
					color: colors.bannerfontcolor,
					width: "100%",
					height: "50px",
					pt: 1,
					fontSize: "25px",
					fontWeight: 600,
					background: colors.bannerbackground,
				}}
			>
				{label}
			</Typography>

			<Box
    			display="flex"
    			alignItems="center"
    			justifyContent="center"
    			sx={{ minHeight: 100, fontSize: "3.5em" }}
			>
    		{icon ? (
        	<>
            <Box sx={{ fontSize: "inherit", paddingTop: "20px" }}>{icon}</Box>
                <Typography
                    sx={{
                        color: colors.displayfontcolor,
                        fontSize: valueFontSize || "50px",
                        fontWeight: 700,
                        whiteSpace: 'normal',
                        lineHeight: 1.2,
                    }}
            	>
                    {value}
                </Typography>
        	</>
    		) : (
        	<Box>
            	{[value, value2, value3].filter(Boolean).map((val, idx) => (
                	<Typography
                    	key={idx}
                    	sx={{
                        	color: colors.displayfontcolor,
                        	fontSize: valueFontSize || "50px",
                        	fontWeight: 700,
                        	whiteSpace: 'normal',
                        	lineHeight: 1.2,
                    	}}
                		>
                    	{val}
                	</Typography>
            	))}
        	</Box>
    		)}
		</Box>
	</Box>
	);
}